import { faChartNetwork } from '@fortawesome/pro-regular-svg-icons'
import { useTranslation } from 'react-i18next'
import { ReportCharm } from './ReportCharm'

export const ReportApiAccessActiveCharm = () => {
  const { t } = useTranslation()
  return <ReportCharm icon={faChartNetwork} label={t('common.active')} />
}
